module.exports = __webpack_public_path__ + "static/media/icon_copy.5a0d2863.svg";